<script>
	const { enableOfflineMode, disableOfflineMode, removeOfflineUserContext, getOfflineModeStatus } = require('utilities/offlineUtilities');
	const utilities = require('utilities');
	const page = require('page');
	const model = require('model/model');

	module.exports = {
		components: {
			'toggle-buttons': require('components/toggle-buttons.vue').default,
			'info-icon': require('components/svg/info-icon.vue').default
		},
		props: {
			disabled: {
				default: false
			}
		},
		modelData: ['offlineMode', 'offlineAssignments', 'userContext', 'enableOfflineModalHide'],
		data() {
			return {
				loading: false,
				offlineTs: null
			};
		},
		computed: {
			offlineAssignmentsList() {
				let offlineAssignments = this.offlineAssignments;
				let userContext = this.userContext;
				let uid = userContext ? userContext.uid : null;
				let classCode = userContext ? userContext.classCode : null;
				let assignments = uid && offlineAssignments ? offlineAssignments[uid] : null;
				let assignmentsList = null; //assignments ? Object.keys(assignments) : null;

				if (assignments) {
					assignmentsList = Object.keys(assignments).filter(a => assignments[a].cc === classCode);
				}

				return assignmentsList;
			},
			options() {
				let offlineMode = this.offlineMode;
				let disabled = this.disabled;
				return [
					{
						value: false,
						label: 'Online',
						selected: offlineMode === false,
						disabled
					},
					{
						value: true,
						label: 'Offline',
						selected: offlineMode,
						disabled
					}
				];
			},
			tokenExpired() {
				let ten_hours = 10 * 60 * 60 * 1000;
				let now = Date.now();
				let offlineTs = this.offlineTs;
				let expired = false;

				if (offlineTs && now - offlineTs > ten_hours) {
					expired = true;
				}
				return expired;
			}
		},
		methods: {
			toggleOfflineMode(item) {
				if (item.value === false && this.offlineMode !== false) {
					this.loading = true;
					utilities.openModal('#modal-disable-offline');
					this.offlineTs = null;
					getOfflineModeStatus().then(status => {
						if (status) {
							this.offlineTs = status.ts;
							this.loading = false;
						}
					});
				} else if (item.value === true && this.offlineMode !== true) {
					enableOfflineMode().then(() => {
						if (!this.enableOfflineModalHide) {
							utilities.openModal('#modal-enable-offline');
						}
					});
				}
				this.$emit('click-item', item);
			},
			onGoOnlineClick() {
				this.loading = true;

				removeOfflineUserContext().then(() => {
					disableOfflineMode().then(() => {
						this.closeModals();
						this.loading = false;
						page('/logout');
					});
				});
			},
			closeModals() {
				utilities.closeModals();
			},
			hideEnableOfflineModal() {
				model.set('enableOfflineModalHide', true);
				this.closeModals();
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	.offline-mode-toggle {
	}
</style>
<template>
	<div
		class="offline-mode-toggle text-centered"
		:class="{
			disabled: typeof offlineMode === 'undefined'
		}">
		<!-- <label>Offline Mode:</label> -->
		<div>
			<button
				v-if="!offlineAssignmentsList || offlineAssignmentsList.length < 1"
				class="button -link"
				v-tooltip="'To enable offline mode, please download an assignment.'">
				<info-icon></info-icon>
			</button>
			<toggle-buttons
				button-flags="-outline -small"
				@click-item="toggleOfflineMode"
				:options="options"></toggle-buttons>
		</div>
		<modal
			ref="modal"
			id="modal-enable-offline"
			:ok="false"
			:centered="true"
			:loading="loading">
			<template slot="header-container">
				<h2>You are going offline</h2>
			</template>
			<div
				slot="content"
				class="modal-enable-offline">
				<p>
					You can now access and complete any downloaded assignments without a connection to the internet. For your teacher to receive submitted
					assignments, you will need to connect to the internet and switch your account to online mode.
				</p>
				<div class="margin-top-bottom-medium">
					<button
						class="button"
						@click="closeModals">
						Ok
					</button>
					<div class="margin-top-medium font-small">
						<button
							class="button -link -link-muted dismiss"
							@click="hideEnableOfflineModal">
							Don't show this message again.
						</button>
					</div>
				</div>
			</div>
		</modal>
		<modal
			ref="modal"
			id="modal-disable-offline"
			:ok="false"
			:centered="true"
			:loading="loading">
			<template slot="header-container">
				<h2>Do you want to go online?</h2>
			</template>
			<div
				slot="content"
				class="modal-disable-offline">
				<p>
					Please ensure you have a stable internet connection before switching your account to online mode. To access your account, you will need to log
					back in.
				</p>
				<p>
					<button
						class="button -outline"
						@click="closeModals">
						Cancel
					</button>
					<button
						class="button"
						@click="onGoOnlineClick">
						Go Online
					</button>
				</p>
			</div>
		</modal>
	</div>
</template>
